import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-blue-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* About */}
            <div>
              <h3 className="text-xl font-bold mb-4">Gizeli Rodrigues</h3>
              <p className="text-blue-200 leading-relaxed">
                Terapeuta especializada em transformação emocional profunda, ajudando pessoas a se libertarem de padrões inconscientes e traumas.
              </p>
              <p className="text-blue-300 mt-4 text-sm">CITRG Nº 11.491</p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xl font-bold mb-4">Links Rápidos</h3>
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={() => document.getElementById('inicio')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-blue-200 hover:text-white transition-colors"
                  >
                    Início
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.getElementById('sobre')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-blue-200 hover:text-white transition-colors"
                  >
                    Quem Sou
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.getElementById('especialidades')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-blue-200 hover:text-white transition-colors"
                  >
                    Especialidades
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.getElementById('formacoes')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-blue-200 hover:text-white transition-colors"
                  >
                    Formações
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-xl font-bold mb-4">Contato</h3>
              <ul className="space-y-2 text-blue-200">
                <li>
                  <a href="https://wa.me/5518998086169" className="hover:text-white transition-colors">
                    WhatsApp: (18) 99808-6169
                  </a>
                </li>
                <li>
                  <a href="mailto:gizeliterapeuta@gmail.com" className="hover:text-white transition-colors break-all">
                    gizeliterapeuta@gmail.com
                  </a>
                </li>
                <li>
                  <a
                    href="https://instagram.com/gizeli.terapeuta"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white transition-colors"
                  >
                    @gizeli.terapeuta
                  </a>
                </li>
                <li className="pt-2">
                  <span className="text-blue-300">Atendimento Online</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-blue-800 pt-8 mt-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-blue-200 text-sm">
                © {new Date().getFullYear()} Gizeli Rodrigues - Todos os direitos reservados
              </p>
              <div className="flex items-center gap-2 text-blue-200 text-sm">
                <span>Feito com</span>
                <Heart size={16} className="text-red-400 fill-current" />
                <span>para transformar vidas</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;